export default "__VITE_ASSET__b0d96707__$_?component__"